import React from "react";
import GlobalCard from "../../../components/GlobalCardComponent";
import { Box, Chip, Grid, Typography } from "@mui/material";
import Loader from "../../../../SAPPages/components/Loader/Loader";

export default function EnrolledClassCard({ attendanceDetails, loading }) {


  return (
    <GlobalCard height="100%" padding="10px">
   
  
      <Grid container spacing={2} px={1}>
        <Grid item xs={12} container gap={1} alignItems="center">
          <Box width={44}>
            <img src="/newdashboard/Classrom/Attendance/Group 1000016696 (1).png" />
          </Box>
          <Typography
            color="#000000"
            fontFamily="Inter"
            fontSize="18px"
            lineHeight="100%"
            letterSpacing="0px"
            fontStyle="normal"
            style={{ fontWeight: 400 }}
          >
            Enrolled Class
          </Typography>
        </Grid>
{loading ? ( 
 <Grid item xs={12}>
        <Loader height="40vh" text="Loading Class Details..."/>
      </Grid>
      )  : (
<>
        <Grid item xs={12}>
          {" "}
          <Box height="1px" sx={{ background: "#dddddd" }} width="100%"></Box>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              container
              alignItems="center"
              flexDirection="row"
              justifyContent="space-between"
              gap={1}
            >
              <Typography
                textAlign="start"
                color="#9D0385"
                fontFamily="Inter"
                fontSize="18px"
                lineHeight="100%"
                letterSpacing="0px"
                fontStyle="normal"
                style={{ fontWeight: 400 }}
              >
                {attendanceDetails?.class_id?.name}
              </Typography>

              <Box
                sx={{
                  px: 1.2,
                  py: 0.6,
                  background:
                    attendanceDetails?.class_id?.mode_of_delivery === "online"
                      ? "#1D98110F"
                      : "#DA03030D",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  borderRadius: "8px",
                }}
              >
                <Box
                  sx={{
                    width: 6,
                    height: 6,
                    background:
                      attendanceDetails?.class_id?.mode_of_delivery === "online"
                        ? "#37A42D"
                        : "#DA0303",
                    borderRadius: "50%",
                  }}
                ></Box>
                <Typography
                  color={
                    attendanceDetails?.class_id?.mode_of_delivery === "online"
                      ? "#37A42D"
                      : "#DA0303"
                  }
                  fontFamily="Inter"
                  fontSize="14px"
                  lineHeight="100%"
                  letterSpacing="0px"
                  fontStyle="normal"
                  style={{ fontWeight: 700 }}
                >
                  {attendanceDetails?.class_id?.mode_of_delivery}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    flexDirection="row"
                    gap={1}
                  >
                    <Box width={30}>
                      <img src="/newdashboard/Checkout/Group 1171283449.png" />
                    </Box>
                    <Typography
                      textAlign="start"
                      color="#444444"
                      fontFamily="Inter"
                      fontSize="14px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                    >
                      Time :{" "}
                      <span style={{ color: "#000000" }}>
                        {" "}
                        {attendanceDetails?.class_id?.start_time} -{" "}
                        {attendanceDetails?.class_id?.end_time}
                      </span>
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    flexDirection="row"
                    gap={1}
                  >
                    <Box width={30}>
                      <img src="/newdashboard/Checkout/Group 1171283449 (1).png" />
                    </Box>
                    <Typography
                      textAlign="start"
                      color="#444444"
                      fontFamily="Inter"
                      fontSize="14px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                    >
                      Trainer :{" "}
                      <span style={{ color: "#000000" }}>
                        {" "}
                        {
                          attendanceDetails?.class_id?.trainer_id?.first_name
                        }{" "}
                        {attendanceDetails?.class_id?.trainer_id?.last_name}
                      </span>
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    display="flex"
                    alignItems="center"
                    flexDirection="row"
                    gap={1}
                  >
                    <Box width={30}>
                      <img src="/newdashboard/Checkout/Group 1171283449 (3).png" />
                    </Box>
                    <Typography
                      textAlign="start"
                      color="#444444"
                      fontFamily="Inter"
                      fontSize="14px"
                      lineHeight="100%"
                      letterSpacing="0px"
                      fontStyle="normal"
                      style={{ fontWeight: 400 }}
                    >
                      Class Days :{" "}
                      <span style={{ color: "#000000" }}>
                        {attendanceDetails?.class_id?.day
                          ?.map((day) => day)
                          .join(", ")}
                      </span>
                    </Typography>
                  </Box>
                </Grid>

                {attendanceDetails?.class_id?.mode_of_delivery ===
                  "offline" && (
                  <>

                   
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="row"
                        gap={1}
                      >
                        <Box width={30} flexShrink={0}>
                          <img src="/newdashboard/Checkout/Group 1171283449 (4).png" />
                        </Box>
                        <Typography
                          textAlign="start"
                          color="#444444"
                          fontFamily="Inter"
                          fontSize="14px"
                          lineHeight="1.4"
                          letterSpacing="0.1px"
                          fontStyle="normal"
                          style={{ fontWeight: 400 }}
                        >
                          Location :{" "}
                          <span style={{ color: "#000000" }}>
                            {" "}
                            {attendanceDetails?.class_id?.branch_id?.address}
                          </span>
                        </Typography>
                      </Box>
                    </Grid>
                  </>
                )}

                {attendanceDetails?.class_id?.mode_of_delivery === "online" && (
                  <Grid item xs={12} sm={12} md={12}>
                    <Box
                      display="flex"
                      alignItems="center"
                      flexDirection="row"
                      gap={1}
                    >
                      <Box width={30} flexShrink={0}>
                        <img src="/newdashboard/Checkout/Group 1171283449 (4).png" />
                      </Box>
                      <Typography
                        textAlign="start"
                        color="#444444"
                        fontFamily="Inter"
                        fontSize="14px"
                        lineHeight="100%"
                        letterSpacing="0px"
                        fontStyle="normal"
                        style={{ fontWeight: 400 }}
                      >
                        Branch :{" "}
                        <span style={{ color: "#000000" }}> Online Class</span>
                      </Typography>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        </>
        )}
      </Grid>
  
    </GlobalCard>
  );
}
